__turbopack_context__.v({
  "className": "uhcsans_5f67aa5f-module__unOI4a__className",
  "variable": "uhcsans_5f67aa5f-module__unOI4a__variable",
});
